'use client';
import { MobileTitle } from '@/components/title';
import { useEffect, useMemo, useRef, useState } from 'react';
import { EnterButton } from './common';
import { getDoubleDimensional } from '@/utils';
import CaseCard from '../components/case-card';
import { DotPage, LinkHref } from '@ssv-website/web-ui';
interface IBox {
  data: HomePageTypes.ArticleItem[];
}
const DoGoodCase = ({ data }: { data: HomePageTypes.Article }) => {
  const { data: list } = data;
  const [current, setCurrent] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const renderList = useMemo(() => getDoubleDimensional(list, 2), [list]);

  useEffect(() => {
    if (ref.current) {
      const offSetWidth = ref.current.offsetWidth;
      const observerScroll = () => {
        if (ref.current) {
          const scrollLeft = ref.current.scrollLeft;
          const active = Math.floor(scrollLeft / offSetWidth);
          setCurrent(active);
        }
      };
      ref.current.addEventListener('scroll', observerScroll);
      return () => {
        ref.current?.removeEventListener('scroll', observerScroll);
      };
    }
  }, []);

  return (
    <>
      <MobileTitle title="向善案例" />
      <div
        className="w-full flex overflow-x-auto hide-scrollbar snap-x snap-mandatory"
        ref={ref}
      >
        {renderList.map((v, i) => (
          <div key={i} className="flex-shrink-0 snap-always snap-center w-full">
            <Box data={v} />
          </div>
        ))}
      </div>
      <div className="mt-4">
        <DotPage current={current} total={renderList?.length} />
      </div>
      <EnterButton text="进入向善案例库" link={LinkHref.Case} />
    </>
  );
};

export default DoGoodCase;
const Box = ({ data }: IBox) => (
  <div className="w-full px-5 box-border flex flex-col gap-3 ">
    {data.map((v, i) => (
      <CaseCard
        key={i}
        imgUrl={v.cover}
        tag={v.tags[0]?.name ?? ''}
        text={v.title}
        link={v.link}
        isMobile
      />
    ))}
  </div>
);
const Dot = ({ total, active }: { total: number; active: number }) => (
  <div className="flex gap-1 mt-4 justify-center">
    {Array(total)
      .fill(null)
      .map((_, i) => (
        <div
          key={i}
          className="w-2 h-1 rounded-[0.25rem]"
          style={{ backgroundColor: active === i ? '#323C46' : '#E2E6EC' }}
        />
      ))}
  </div>
);
